exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/learn/blog/posts/02/get-it-done.component.scss
// module id = ../../../../../src/app/learn/blog/posts/02/get-it-done.component.scss
// module chunks = main